var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"height-100 d-flex justify-center align-center"},[_c('div',{staticClass:"text-center rounded-lg",attrs:{"id":"info-page-card"}},[_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }